import React from 'react';
import cx from 'classnames';
import './UserStatusWrapper.scss';

export const UserStatusWrapper = ({ children, isCentered, displayFooter }) => {
	const className = cx({
		'userstatus-wrapper': true,
		'userstatus-wrapper--centered': isCentered,
		'userstatus-wrapper--display-footer': displayFooter,
	});

	return <div className={className}>{children}</div>;
};
